import _ from 'lodash';
import { PriorityOptions, ProgressOptions, ROLES, rolesOption } from '../constants';
import { store } from '../redux/store';
import dayjs from 'dayjs';
import { Flex } from 'antd';

export const isSuperAdmin = () => store.getState().authSlice.user?.role === ROLES.SUPERADMIN;
export const isAdmin = () => store.getState().authSlice.user?.role === ROLES.ADMIN;
export const isManager = () => store.getState().authSlice.user?.role === ROLES.MANAGER;
export const isStaff = () => store.getState().authSlice.user?.role === ROLES.STAFF;

export const allowEdit = (targetRole) => {
  const rolePermissions = {
    0: [0, 1, 2, 3],
    1: [1, 2, 3],
    2: [2, 3],
    3: [],
  };

  return (
    !rolePermissions[store.getState().authSlice.user?.roleValue]?.includes(targetRole) || false
  );
};

export const generateUniqueId = () => {
  return Math.random().toString(36).substr(2, 9);
};

export const getLabelDetail = (label) => {
  const labelOption = store.getState().labelsSlice?.labels?.find((el) => el.label === label);
  return labelOption;
};

export const updateOrderById = (data, newOrder) => {
  const orderMap = newOrder?.reduce((acc, { key, order }) => {
    acc[key] = order;
    return acc;
  }, {});

  const updatedData = data?.map((item) => ({
    ...item,
    order: orderMap[item.key] !== undefined ? orderMap[item.key] : item.order,
  }));

  return _.sortBy(updatedData, 'order');
};

export const customDate = (date, comparisonDate) => {
  if (!date) return '-';
  const dueDate = dayjs(date);
  const now = comparisonDate ? dayjs(comparisonDate) : dayjs();
  return {
    isOverdue: dueDate.isBefore(now),
    formattedDate: dueDate.format('DD/MM/YYYY'),
    formattedTime: dueDate.format('HH:mm'),
    fullDate: dueDate.format('DD/MM/YYYY HH:mm'),
  };
};

export const calculateNextDue = ({ dueDate, schedule, interval = 1 }) => {
  if (!dueDate || !schedule) {
    console.error('Missing required inputs for calculateNextDue');
    return null;
  }

  const dueDateTime = dayjs(dueDate);

  if (!dueDateTime.isValid()) {
    console.error('Invalid dueDate format');
    return null;
  }

  let nextDue;

  switch (schedule.toLowerCase()) {
    case 'day':
    case 'daily':
      nextDue = dueDateTime.add(interval, 'day');
      break;

    case 'week':
    case 'weekly':
      nextDue = dueDateTime.add(interval, 'week');
      break;

    case 'month':
    case 'monthly':
      nextDue = dueDateTime.add(interval, 'month');
      break;

    case 'year':
    case 'yearly':
      nextDue = dueDateTime.add(interval, 'year');
      break;

    case 'weekdays': {
      nextDue = dueDateTime.add(interval, 'day');
      while (nextDue.day() === 0 || nextDue.day() === 6) {
        nextDue = nextDue.add(1, 'day');
      }
      break;
    }

    default:
      console.error('Unsupported schedule type');
      return null;
  }
  return nextDue.format('YYYY-MM-DD HH:mm:ss');
};

export const getRoleByValue = (value) => {
  const role = rolesOption.find((role) => role.value === value) || null;
  return role?.label;
};

export const getFullName = (user) => {
  return `${user?.first_name} ${user?.last_name ?? ''}`;
};

export const formatAttachments = (fileList) => {
  const list = [];
  const fileNames = [];

  fileList?.forEach((file) => {
    list.push(file?.payload);
    fileNames.push(file?.name);
  });

  return {
    list,
    fileNames,
  };
};

export const progressWithIcon = (progress) => {
  const option = ProgressOptions.find((el) => el.value === progress);
  return (
    <Flex align="center" gap={8}>
      {option?.icon}
      {option?.label}
    </Flex>
  );
};

export const priorityWithIcon = (progress) => {
  const option = PriorityOptions.find((el) => el.value === progress);
  return (
    <Flex align="center" gap={8}>
      {option?.icon}
      {option?.label}
    </Flex>
  );
};

export function getNewFileName(oldFileName) {
  const extension = oldFileName?.slice(oldFileName?.lastIndexOf('.'));
  const baseName = oldFileName?.slice(0, oldFileName?.lastIndexOf('.'));
  const randomString = Math.random().toString(36).substring(2, 12);
  return `${baseName}-${randomString}${extension}`;
}

export function extractOriginalFileName(modifiedFileName) {
  const extensionIndex = modifiedFileName?.lastIndexOf('.');
  modifiedFileName?.slice(extensionIndex);
  const randomStringPattern = /-\w{10}(?=\.\w+$)/;
  const baseName = modifiedFileName?.replace(randomStringPattern, '');
  return baseName;
}

export const generateAvatarColor = (name) => {
  if (!name) return { bg: '#E2E2E2', text: '#424242' };

  const colors = [
    { bg: '#B3E5FC', text: '#01579B' },
    { bg: '#E1BEE7', text: '#4A148C' },
    { bg: '#C8E6C9', text: '#1B5E20' },
    { bg: '#FFE0B2', text: '#E65100' },
    { bg: '#FFCDD2', text: '#B71C1C' },
    { bg: '#DCEDC8', text: '#33691E' },
    { bg: '#B2DFDB', text: '#004D40' },
    { bg: '#D7CCC8', text: '#3E2723' },
  ];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
};
